export var GOODS_STATUS;
(function (GOODS_STATUS) {
    GOODS_STATUS[GOODS_STATUS["CAN_SALE"] = 1] = "CAN_SALE";
    GOODS_STATUS[GOODS_STATUS["CAN_NOT_SALE"] = 2] = "CAN_NOT_SALE";
})(GOODS_STATUS || (GOODS_STATUS = {}));
export var GOODS_TYPE;
(function (GOODS_TYPE) {
    GOODS_TYPE[GOODS_TYPE["DEAL"] = 3] = "DEAL";
    GOODS_TYPE[GOODS_TYPE["TONG_DUI"] = 6] = "TONG_DUI";
    GOODS_TYPE[GOODS_TYPE["SUPER_GROUP"] = 11] = "SUPER_GROUP";
})(GOODS_TYPE || (GOODS_TYPE = {}));
export var LOAD_MORE_TYPE;
(function (LOAD_MORE_TYPE) {
    LOAD_MORE_TYPE[LOAD_MORE_TYPE["BUTTON"] = 1] = "BUTTON";
    LOAD_MORE_TYPE[LOAD_MORE_TYPE["PULL_UP"] = 2] = "PULL_UP";
    LOAD_MORE_TYPE[LOAD_MORE_TYPE["LINK"] = 3] = "LINK";
})(LOAD_MORE_TYPE || (LOAD_MORE_TYPE = {}));
